// Watch for the document to be ready
document.addEventListener('DOMContentLoaded', function() {
    // Watch for the select input id cart__besteller and save the changed value to local storage
    // If value is present initialize the select with the value - make sure always keep them in sync
    var cartBestellers = document.querySelectorAll('.cart__besteller');
    if (cartBestellers) {
        renderItems(cartBestellers)
    }

    

    // If element not found in the DOM then try again in 3 seconds
    setTimeout(function() {
        var cartBestellers = document.querySelectorAll('.cart__besteller');
        if (!cartBestellers) {
            console.log('Element not found');
        }else {
            renderItems(cartBestellers)
        }
    }, 3000);
});
function renderItems(cartBestellers) {
    cartBestellers.forEach(function(cartBesteller) {
        // Add an event listener to each element
        cartBesteller.addEventListener('change', function() {
            // Save the value of each element in local storage with a unique key
            localStorage.setItem('cart__besteller', this.value);
        });

        // Initialize each element with its saved value, if it exists
        var savedValue = localStorage.getItem('cart__besteller');
        if (savedValue) {
            cartBesteller.value = savedValue;
        }
    });
}